export const formatFileSize = (size?: number) => {
  if (!size) return "Tamanho não disponível";
  return size < 1024 * 1024
    ? `${(size / 1024).toFixed(1)} KB`
    : `${(size / (1024 * 1024)).toFixed(2)} MB`;
};
